// Utility to extract city, state, and country from a location string
export function extractLocation(dataString) {
    // Remove "City: " prefix if present and split before ', Check-in' if present
    let str = dataString.replace(/^City: /, '').split(', Check-in')[0];
    // Split by comma, trim spaces, and filter out empty strings
    const parts = str.split(',').map(s => s.trim()).filter(Boolean);
    return {
        city: parts[0] || '',
        state: parts[1] || '',
        country: parts[2] || ''
    };
} 